module.exports = __webpack_public_path__ + "img/mailouts-mailbox-processing.c41b0704.svg";